var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"template-id":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e12e678","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/sstv-bug.vue
// module id = 1770
// module chunks = 1